export default __webpack_public_path__ + "static/media/microsoftSql.7e3c2025.svg";